module.exports = __webpack_public_path__ + "5e063156f88ff9f0c88340cf350d2e92.pdf";